//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
import config from '../../config';

//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import DeletePopup from "../Common/Popup/DeletePopup";
import ViewPopup from "../Common/Popup/ViewPopup";
import EditPopup from "../Common/Popup/EditPopup";
import { userActions } from "../../_actions";
import { categoryActions } from "../../_actions";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';


class PromoCode extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            getCouponList: [],
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            advertisments: {
                title: '',
                advertisment_image: '',
            },
            popupType: '',
            addButton: false,
            promocodeAdd: false,
            shopKeeperData: [],
            promocodeTitle: '',
            promoCodeValue: '',
            addPromoType: '',
            promoCodeError: '',
            promocodeSuccess: '',
            allCategories: [],
            addPromoCode: false,
            editingCatId: '',
            editingCatTitle: '',
            editingCatStatus: '',
            editingCatHold: false
        };
    }

    /*
    * componentDidMount - Initially it will call and get the advertisments data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;

        // dispatch(categoryActions.getAllCategory(apiConstants.GET_CATEGORIES, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {

        console.log(props);

        const { dispatch } = props;
        //check if category already exist with same name
        if (
            props.addCategory !== undefined &&
            props.addCategory.addedCat !== undefined &&
            props.addCategory.addedCat === false
        ) {
            this.setState({ promoCodeError: 'Category with same name already exist!!', promocodeSuccess: '' })
        }

        //IF CATEGORY ADDED SUCCESSFULLY
        if (
            props.addCategory !== undefined &&
            props.addCategory.addedCat !== undefined &&
            props.addCategory.addedCat.data !== undefined &&
            props.addCategory.addedCat.data.success !== undefined &&
            props.addCategory.addedCat.data.success === true
        ) {
            this.setState({ promocodeSuccess: 'Category added successfully!!', promoCodeError: '' });
            const thisHolder = this;
            setTimeout(function () {
                if (thisHolder.state.addPromoCode === true) {

                    thisHolder.closeAddPromoPop();

                    let postData = {};
                    postData.page = 1;
                    postData.orderBy = "id";
                    postData.orderByAscDesc = "ASC";
                    postData.perPage = config.perPageData;
                    dispatch(categoryActions.getAllCategory(apiConstants.GET_CATEGORIES, postData));

                }
            }, 2000);
        }


        // GET LIST OF CATEGORIES SUCCESS        
        if (props.getCategories !== undefined &&
            props.getCategories.getCatList !== undefined &&
            props.getCategories.getCatList.data !== undefined
        ) {
            const catDataReceived = props.getCategories.getCatList.data;

            // if ( this.state.addPromoCode === true || this.state.triggerEditCat === true ) {
            this.setState({
                allCategories: catDataReceived,
                totalPage: catDataReceived.pagination.totalPages,
                totalDataCount: catDataReceived.pagination.totalCount,
            })
            // }
        }

        // check if category is ready to edit  
        if (props.getCategory !== undefined &&
            props.getCategory.editCatData !== undefined &&
            props.getCategory.editCatData.data !== undefined &&
            props.getCategory.editCatData.data.result !== undefined
        ) {
            const editingCatData = props.getCategory.editCatData.data.result;

            if (this.state.editingCatHold === true) {
                this.setState({
                    editingCatTitle: editingCatData.promocodeTitle,
                    editingCatStatus: editingCatData.status,
                    editingCatHold: false
                })
            }

        }


        //check if category already exist with same name while editing
        if (
            props.editCategory !== undefined &&
            props.editCategory.editedCat !== undefined &&
            props.editCategory.editedCat === false
        ) {
            this.setState({ editingCategoryError: 'Category with same name already exist!!', editingpromocodeSuccess: '' })
        }


        // IF CATEGORY UPDATED SUCCESSFULLY
        if (
            props.editCategory !== undefined &&
            props.editCategory.editedCat !== undefined &&
            props.editCategory.editedCat.data !== undefined &&
            props.editCategory.editedCat.data.success === true
        ) {
            this.setState({ editingCategoryError: '', editingpromocodeSuccess: 'Category updated succesfully!!' });
            const thisHolder = this;
            setTimeout(function () {
                if (thisHolder.state.triggerEditCat === true) {

                    thisHolder.closeEditCatPop();

                    let postData = {};
                    postData.page = 1;
                    postData.orderBy = "id";
                    postData.orderByAscDesc = "ASC";
                    postData.perPage = config.perPageData;
                    dispatch(categoryActions.getAllCategory(apiConstants.GET_CATEGORIES, postData));

                }
            }, 2000);
        }

    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;

        dispatch(categoryActions.getAllCategory(apiConstants.GET_CATEGORIES, postData));
    }

    // hit api and get category data for selected list range
    changeTableData = (e) => {
        const { dispatch } = this.props;

        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = parseInt(e.target.value);

        dispatch(categoryActions.getAllCategory(apiConstants.GET_CATEGORIES, postData));
    }

    /*
    * searchCategories - User can search data from the database and it will appear
    */
    searchCategories(keyword) {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;


        if (keyword.target.value !== '') {
            postData.search = keyword.target.value;
            dispatch(categoryActions.getAllCategory(apiConstants.FIND_CATEGORIES, postData));
        } else {
            dispatch(categoryActions.getAllCategory(apiConstants.GET_CATEGORIES, postData));
        }
    }

    //-- Popup Handler
    /*
    *   Modal open-close functionality
    */
    popupOpen = (advertisments, type, btnClick) => {
        //-- check add button clicked
        if (btnClick === 'addButton') {
            this.setState({ addButton: true });
            this.setState({ popupType: 'AddShopkeeper' })
        }
        //this.setState({ advertisments, [type]: true })
    };



    /*
    *   Close the popup
    */
    popupClose = (type) => {
        this.setState({
            advertisments: {
                title: '',
                type: '',
                advertisment_image: '',
            },
            addButton: false,
            [type]: false
        });
    };

    //on change set category title to state
    onChangePromoTitle = (e) => {
        this.setState({
            promocodeTitle: e.target.value,

        })
    }
    onChangeEditCatTitle = (e) => {
        this.setState({ editingCatTitle: e.target.value })
    }
    onChangeEditCatDropdown = (e) => {
        this.setState({ editingCatStatus: e.target.value })
    }

    holdPromoType = (e) => {
        this.setState({ addPromoType: e.target.value })
    }

    onChangePromoValue = (e) => {
        this.setState({ promoCodeValue: e.target.value })
    }


    //close add category popup
    closeAddPromoPop = () => {
        this.setState({
            promocodeSuccess: '',
            promocodeAdd: false,
            addPromoCode: false,
            promoCodeValue: '',
            addPromoType: '',
            promocodeTitle: ''

        })
    }

    //save category to collection
    handleSubmit = () => {
        const { dispatch } = this.props;
        const { promocodeTitle, promoCodeValue, addPromoType } = this.state;

        if (promoCodeValue === '' || addPromoType === '' || promocodeTitle === '') {
            this.setState({ promoCodeError: 'All the fields are required!!' })
        } else {
            this.setState({ promoCodeError: '', addPromoCode: true })
        }
        const postData = {};
        postData.catTitle = promocodeTitle;

        // dispatch(categoryActions.saveCategory(apiConstants.SAVE_CATEGORY, postData));

    }


    handleSubmitEditCat = () => {
        const { dispatch } = this.props;
        const editingCatTitle = this.state.editingCatTitle;
        if (editingCatTitle === undefined || editingCatTitle === '') {
            this.setState({ editingCategoryError: 'Category title required!!' })
        } else {
            this.setState({ editingCategoryError: '', editCat: true, triggerEditCat: true, })
        }
        const postData = {};
        postData.catId = this.state.editingCatId;
        postData.catTitle = editingCatTitle;
        postData.catStatus = this.state.editingCatStatus;

        dispatch(categoryActions.editCategory(apiConstants.EDIT_CATEGORY, postData));
    }


    // popup for editing the category
    editCategories = (catId) => {
        const { dispatch } = this.props;
        this.setState({
            editingCatId: catId,
            enableEditingCat: true,
            editingCategoryError: '',
            editingpromocodeSuccess: '',
            editingCatHold: true
        });

        const postData = {};
        postData.catId = catId;

        dispatch(categoryActions.getCategoryById(apiConstants.GET_CATEGORY_BY_ID, postData));
    }

    closeEditCatPop = () => {
        this.setState({ editingCatId: '', enableEditingCat: false, triggerEditCat: false });
    }


    openAddPromocode = () => {
        this.setState({
            promocodeAdd: !this.state.promocodeAdd,
            promocodeSuccess: '',
            promocodeTitle: '',
            addPromoCode: false
        });

    }

    handleClose = () => {
        this.setState({ promocodeAdd: !this.state.promocodeAdd })
    };

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-gray-800">{siteConstants.MENU_PROMOCODE}</h1>
                                <a href="javascript:void(0)"
                                    onClick={() => this.openAddPromocode()}
                                >
                                    <span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>
                                </a>

                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.changeTableData(e)} />

                                            <div className="col-sm-12 col-md-6">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        <input type="search" placeholder={siteConstants.GEN_SEARCH} className="form-control form-control-sm" aria-controls="dataTable" onChange={(e) => this.searchCategories(e)} />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>



                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="10%">{siteConstants.GEN_CATEGORY_TITLE}</th>
                                                    <th scope="col">{siteConstants.GEN_CATEGORY_STATUS}</th>
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            {/* <tfoot>
                                                <tr>
                                                    <th scope="col">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="10%">{siteConstants.GEN_CATEGORY_TITLE}</th>
                                                    <th scope="col">{siteConstants.GEN_CATEGORY_STATUS}</th>    
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </tfoot> */}
                                            <tbody>
                                                {
                                                    this.state.allCategories.data != undefined &&
                                                        this.state.allCategories.data.length > 0 ?
                                                        this.state.allCategories.data.map((thisCat, index) => {
                                                            let stText = 'Active';
                                                            if (thisCat.status === 2) { stText = 'Deactive'; }

                                                            return (

                                                                <tr key={index}>
                                                                    <td scope="row">{index + 1}</td>
                                                                    <td>{thisCat.promocodeTitle}</td>
                                                                    <td>{stText}</td>
                                                                    <td>
                                                                        <a
                                                                            className="actionIcon"
                                                                            title="Edit"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.editCategories(thisCat._id)}
                                                                        ><span><img src="assets/img/svg/EditIcon.png" alt="Edit" /></span></a>
                                                                        <a className="actionIcon"
                                                                            title="Delete"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.DeletePopupOpen(thisCat._id, 'deleteOpen', 'deleteClick')}
                                                                        ><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                            <td colSpan="5" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    {/* add promocode popup */}
                    <Dialog
                        open={this.state.promocodeAdd}
                        aria-labelledby="promocode-title"
                        aria-describedby="save-promocode-description"
                    >
                        <DialogTitle id="crop-image-dialog-title">{siteConstants.LABEL_ADD_PROMO_POPUP}</DialogTitle>
                        <div className="col-md-12 col-xs-12">
                            <div className="form-group">
                                <label>{siteConstants.LABEL_PROMO_TITLE}</label>
                                <input
                                    type="text"
                                    onChange={(e) => this.onChangePromoTitle(e)}
                                    placeholder={siteConstants.LABEL_PROMO_TITLE}
                                    className="form-control"
                                    value={this.state.promocodeTitle}
                                />
                            </div>
                        </div>
                        <div className="col-md-12 col-xs-12">
                            <div className="form-group">

                                <label>{siteConstants.LABEL_PROMO_TYPE}</label>
                                <select className="form-control" onChange={(e) => this.holdPromoType(e)}>
                                    <option></option>
                                    <option value="flat">Flat</option>
                                    <option value="Percent">Percent</option>
                                </select>

                            </div>
                        </div>
                        <div className="col-md-12 col-xs-12">
                            <div className="form-group">
                                <label>{siteConstants.LABEL_PROMO_VALUE}</label>
                                <input
                                    type="number"
                                    min="0"
                                    onChange={(e) => this.onChangePromoValue(e)}
                                    placeholder={siteConstants.LABEL_PROMO_VALUE}
                                    className="form-control"
                                />
                                <p style={{ color: 'red' }}>{this.state.promoCodeError}</p>
                                <p style={{ color: 'green' }}>{this.state.promocodeSuccess}</p>
                            </div>
                        </div>


                        <DialogActions>
                            <Button variant="contained" onClick={() => this.closeAddPromoPop()}>{siteConstants.LABEL_CANCEL}</Button>
                            <Button variant="contained" color="primary" onClick={(e) => this.handleSubmit(e)}>{siteConstants.LABEL_SAVE}</Button>
                        </DialogActions>
                    </Dialog>



                    {/* edit category popup */}
                    <Dialog
                        open={this.state.enableEditingCat}
                        aria-labelledby="edit-category-title"
                        aria-describedby="edit-category-description"
                    >
                        <DialogTitle id="crop-image-dialog-title">{siteConstants.LABEL_CATEGORY_EDIT_POPUP}</DialogTitle>
                        <div className="col-md-12 col-xs-12">
                            <div className="form-group">
                                <label>{siteConstants.LABEL_CATEGORY_FIELD}</label>
                                <input
                                    type="text"
                                    min="0"
                                    onChange={(e) => this.onChangeEditCatTitle(e)}
                                    placeholder={siteConstants.LABEL_CATEGORY_FIELD}
                                    className="form-control"
                                    value={this.state.editingCatTitle !== undefined ? this.state.editingCatTitle : ''}
                                />
                            </div>
                        </div>
                        <div className="col-md-12 col-xs-12">
                            <div className="form-group">
                                <label>{siteConstants.LABEL_CATEGORY_FIELD}</label>
                                <select
                                    onChange={(e) => this.onChangeEditCatDropdown(e)}
                                    className="form-control"
                                >
                                    <option value="1" selected={this.state.editingCatStatus === 1}>Active</option>
                                    <option value="2" selected={this.state.editingCatStatus === 2}>Deactive</option>
                                </select>
                            </div>
                        </div>

                        <div className="col-md-12 col-xs-12">
                            <p style={{ color: 'red' }}>{this.state.editingCategoryError}</p>
                            <p style={{ color: 'green' }}>{this.state.editingpromocodeSuccess}</p>
                        </div>

                        <DialogActions>
                            <Button variant="contained" onClick={() => this.closeEditCatPop()}>{siteConstants.LABEL_CANCEL}</Button>
                            <Button variant="contained" color="primary" onClick={(e) => this.handleSubmitEditCat(e)}>{siteConstants.LABEL_SAVE}</Button>
                        </DialogActions>
                    </Dialog>


                    <Footer />
                </div>



            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, addCategory, getCategories, getCategory, editCategory } = state;
    return {
        language,
        addCategory,
        getCategories,
        getCategory,
        editCategory
    };
}

const connectedShopkeeper = connect(mapStateToProps)(PromoCode);
export { connectedShopkeeper as PromoCode };